import { Link } from "react-router-dom";
import posDeviceData from "../../../lib/Json/prouctData.json";

function DeviceListing() {
  return (
    <div>
      <h4 className="text-base sm:text-xl poppins_semibold mb-5 bg-slate-800 text-white text-center py-2">
        Portable Mobile Devices - Android
      </h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {posDeviceData
          ?.filter((device) => device.deviceType === 1)
          .map((deviceData) => {
            return (
              <Link
                key={deviceData.id}
                className="h-full group"
                to={`/product/${deviceData.id}`}
              >
                <div class="relative flex h-full w-full lg:max-w-xs flex-col overflow-hidden rounded-lg border border-gray-100 bg-white shadow-md">
                  <div class="relative flex p-5 rounded-t-lg bg-[radial-gradient(circle,#C1C0BC,#D7D6D2)] image-wrapper image-shine">
                    <img
                      className="object-cover group-hover:scale-90 transform duration-300"
                      src={deviceData.productImage}
                      alt={deviceData.name}
                    />
                  </div>
                  <div class="mt-4 px-5 pb-5">
                    <div className="w-5 mb-2">
                      <img src={deviceData.os} alt={deviceData.name} />
                    </div>
                    <div
                      className="text-md poppins_semibold tracking-tight text-gray-900 group-hover:text-[#2874F0] transition-all duration-300"
                      dangerouslySetInnerHTML={{ __html: deviceData.name }}
                    />
                    <ul className="list-disc ml-5 py-4 space-y-1 text-sm poppins_light">
                      {deviceData?.feature?.map((featureData, featureIndex) => (
                        <li
                          key={featureIndex}
                          className="text-[#C2C2C2] leading-5 tracking-wide"
                        >
                          <span className="text-black">{featureData}</span>
                        </li>
                      ))}
                    </ul>
                    <a
                      href="#"
                      class="flex items-center justify-center rounded-md bg-[#f6892f] px-5 py-2.5 text-center text-sm poppins_medium text-white group-hover:bg-[#ffb77c] focus:outline-none focus:ring-4 focus:ring-blue-300"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </Link>
            );
          })}
      </div>

      <h4 className="text-base sm:text-xl poppins_semibold my-5 bg-slate-800 text-white text-center py-2">
        Desktop Devices - Android
      </h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {posDeviceData
          ?.filter((device) => device.deviceType === 2)
          .map((deviceData) => {
            return (
              <Link
                key={deviceData.id}
                className="h-full group"
                to={`/product/${deviceData.id}`}
              >
                <div class="relative flex h-full w-full lg:max-w-xs flex-col overflow-hidden rounded-lg border border-gray-100 bg-white shadow-md">
                  <div class="relative flex p-5 rounded-t-lg bg-[radial-gradient(circle,#C1C0BC,#D7D6D2)] image-wrapper image-shine">
                    <img
                      className="object-cover group-hover:scale-90 transform duration-300"
                      src={deviceData.productImage}
                      alt={deviceData.name}
                    />
                  </div>
                  <div class="mt-4 px-5 pb-5">
                    <div className="w-5 mb-2">
                      <img src={deviceData.os} alt={deviceData.name} />
                    </div>
                    <div
                      className="text-md poppins_semibold tracking-tight text-gray-900 group-hover:text-[#2874F0] transition-all duration-300"
                      dangerouslySetInnerHTML={{ __html: deviceData.name }}
                    />
                    <ul className="list-disc ml-5 py-4 space-y-1 text-sm poppins_light">
                      {deviceData?.feature?.map((featureData, featureIndex) => (
                        <li
                          key={featureIndex}
                          className="text-[#C2C2C2] leading-5 tracking-wide"
                        >
                          <span className="text-black">{featureData}</span>
                        </li>
                      ))}
                    </ul>
                    <a
                      href="#"
                      class="flex items-center justify-center rounded-md bg-[#f6892f] px-5 py-2.5 text-center text-sm font-medium text-white group-hover:bg-[#ffb77c] focus:outline-none focus:ring-4 focus:ring-blue-300"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </Link>
            );
          })}
      </div>

      <h4 className="text-base sm:text-xl poppins_semibold my-5 bg-slate-800 text-white text-center py-2">
        Desktop Devices - Windows
      </h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {posDeviceData
          ?.filter((device) => device.deviceType === 3)
          .map((deviceData) => {
            return (
              <Link
                key={deviceData.id}
                className="h-full group"
                to={`/product/${deviceData.id}`}
              >
                <div class="relative flex h-full w-full lg:max-w-xs flex-col overflow-hidden rounded-lg border border-gray-100 bg-white shadow-md">
                  <div class="relative flex p-5 rounded-t-lg bg-[radial-gradient(circle,#C1C0BC,#D7D6D2)] image-wrapper image-shine">
                    <img
                      className="object-cover group-hover:scale-90 transform duration-300"
                      src={deviceData.productImage}
                      alt={deviceData.name}
                    />
                  </div>
                  <div class="mt-4 px-5 pb-5">
                    <div className="w-5 mb-2">
                      <img src={deviceData.os} alt={deviceData.name} />
                    </div>
                    <div
                      className="text-md poppins_semibold tracking-tight text-gray-900 group-hover:text-[#2874F0] transition-all duration-300"
                      dangerouslySetInnerHTML={{ __html: deviceData.name }}
                    />
                    <ul className="list-disc ml-5 py-4 space-y-1 text-sm poppins_light">
                      {deviceData?.feature?.map((featureData, featureIndex) => (
                        <li
                          key={featureIndex}
                          className="text-[#C2C2C2] leading-5 tracking-wide"
                        >
                          <span className="text-black">{featureData}</span>
                        </li>
                      ))}
                    </ul>
                    <a
                      href="#"
                      class="flex items-center justify-center rounded-md bg-[#f6892f] px-5 py-2.5 text-center text-sm font-medium text-white group-hover:bg-[#ffb77c] focus:outline-none focus:ring-4 focus:ring-blue-300"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </Link>
            );
          })}
      </div>
    </div>
  );
}

export default DeviceListing;
